<template>
	<div class="chat-historial">

		<ul>

			<li
				v-for="item in contacts"
				:key="item.id"
				@click="$emit('partner', item)"
			>

				<span
					:class="{ aviso: item.aviso, active: partner.id === item.id }"
				><i class="el-icon-user"></i> {{ item.name }}</span>

				<i
					class="el-icon-video-camera"
					@click="$emit('camera', item)"
				></i>

			</li>

		</ul>

	</div>
</template>

<script>
	export default {
		name: 'ChatHistorial',
		props: {
			ws: {
				required: true
			},
			user: {
				type: Object,
				required: true
			},
			partner: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				contacts: []
			}
		},
		created () {

			this.ws.onMsg('usuarios', this.onUsuarios)

			this.ws.onMsg('msg', this.onMsg)

		},
		mounted () { this.ws.sendMsg('usuarios') },
		beforeDestroy () {

			this.ws.delMsg('usuarios', this.onUsuarios)

			this.ws.delMsg('msg', this.onMsg)

		},
		methods: {

			onUsuarios (usuarios) {

				const users = new Set()

				usuarios.filter(u => u.id !== this.user.id).forEach(u => users.add(u.id))

				this.contacts = Array.from(users).map(u => ({
					...usuarios.find(us => us.id === u),
					aviso: false
				}))

			},

			onMsg (msg) {

				if (msg.sender.id === this.user.id) return

				if (this.partner.id && msg.sender.id === this.partner.id && document.hidden === false) return

				this.contacts.find(c => c.id === msg.sender.id).aviso = true

			},

		}
	}
</script>
